var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.48 1.92002C15.92 2.16002 15.28 2.32002 14.64 2.40002C15.28 2.00002 15.84 1.36003 16.08 0.640027C15.44 1.04003 14.8 1.28003 14 1.44003C13.44 0.800027 12.56 0.400024 11.68 0.400024C9.92 0.400024 8.48 1.84002 8.48 3.60002C8.48 3.84002 8.48 4.08002 8.56 4.32002C5.92 4.16002 3.52 2.88002 1.92 0.960022C1.68 1.44002 1.52 2.00002 1.52 2.56002C1.52 3.68002 2.08 4.64002 2.96 5.20002C2.4 5.20002 1.92 5.04002 1.52 4.80002C1.52 6.32002 2.64 7.68002 4.08 7.92002C3.84 8.00002 3.52 8.00002 3.2 8.00002C2.96 8.00002 2.8 8.00002 2.56 7.92002C2.96 9.20002 4.16 10.16 5.6 10.16C4.48 11.04 3.12 11.52 1.6 11.52C1.36 11.52 1.12 11.52 0.800003 11.44C2.24 12.32 3.92 12.88 5.76 12.88C11.68 12.88 14.88 8.00002 14.88 3.76002V3.36002C15.52 3.12002 16.08 2.56002 16.48 1.92002Z",
    fill: "var(--clr-primary)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.74187535.svg";
export { ForwardRef as ReactComponent };